import { action } from 'typesafe-actions';

import { IKnoOrganizationDictionary } from 'APIPackage/DictionariesModule/interfaces/IKnoOrganizationDictionary';
import { IRiskCategory248 } from 'APIPackage/DictionariesModule/interfaces/IRiskCategory248';
import { IDictionary } from 'APIPackage/DictionariesModule/interfaces/IDictionary';
import { IDictionaryValue } from 'APIPackage/DictionariesModule/interfaces/IDictionaryValue';
import { IDictionaryValues } from 'APIPackage/DictionariesModule/interfaces/IDictionaryValues';
import { IDictionaryVersion } from 'APIPackage/DictionariesModule/interfaces/IDictionaryVersion';
import { IKnmKind } from 'APIPackage/DictionariesModule/interfaces/IKnmKind';
import { IProfKind } from 'APIPackage/DictionariesModule/interfaces/IProfKind';
import { IPosition } from 'APIPackage/DictionariesModule/interfaces/IPosition';
import { ISubjectType } from 'APIPackage/DictionariesModule/interfaces/ISubjectType';
import { ISubjectKind } from 'APIPackage/DictionariesModule/interfaces/ISubjectKind';
import { IEventType } from 'APIPackage/DictionariesModule/interfaces/IEventType';
import { ISupervisionType } from 'APIPackage/DictionariesModule/interfaces/ISupervisionType';
import { IAcceptedDocument } from 'APIPackage/DictionariesModule/interfaces/IAcceptedDocument';
import { IChecklistDictionary } from 'APIPackage/DictionariesModule/interfaces/IChecklistDictionary';
import { IRiskIndicatory } from 'APIPackage/DictionariesModule/interfaces/IRiskIndicatory';
import { IRequirement } from 'APIPackage/DictionariesModule/interfaces/IRequirement';
import { IDangerClass248 } from 'APIPackage/DictionariesModule/interfaces/IDangerClass248';
import { IParticipantPosition } from 'APIPackage/DictionariesModule/interfaces/IParticipantPosition';
import { ITargetEntity } from 'APIPackage/DictionariesModule/interfaces/ITargetEntity';
import { IKnmType } from 'APIPackage/CatalogsModule/interfaces/IKnmType';
import { IDecisionKind } from 'APIPackage/DictionariesModule/interfaces/IDecisionKind';
import { IApplicationConditionSubject } from 'APIPackage/AccountModule/interfaces/IApplicationConditionSubject';
import { IFederalLawErvk } from 'APIPackage/CatalogsModule/interfaces/IFederalLawErvk';
import { IKnmSubjectTypesERVK } from 'APIPackage/CatalogsModule/interfaces/IKnmSubjectTypesERVK';

import { IPermitDocs } from '../../../APIPackage/DictionariesModule/interfaces/IPermitDocs';
import { DictionariesActionsEnum } from '../enums/DictionariesActionsEnum';
import { DictionaryNamesEnum } from '../enums/DictionaryNamesEnum';
import { DictionaryUUIDsEnum } from '../enums/DictionaryUUIDsEnum';
import { IPairKnoSupervisionVersions } from '../interfaces/IPairKnoSupervisionVersions';
import { IErvkCheckList } from '../../../APIPackage/DictionariesModule/interfaces/IErvkCheckList';
import { ITripletKnoSupervisionCondition } from '../interfaces/ITripletKnoSupervisionCondition';
import { IControlWithDate } from '../../../APIPackage/DictionariesModule/interfaces/IControlWithDate';
import { IKnmReasonType } from '../../../APIPackage/CatalogsModule/interfaces/IKnmReasonType';
import { ISelectOption } from '../../../UIPackage/MainModule/components/SelectInput';

interface IDictionariesChecklistsItemGetParams {
  uuidKno: string;
  uuidSupervision: string;
}

interface IDictionariesRequirementsItemGetParams {
  uuidKno: string;
  uuidSupervision: string;
}

export interface IErvkListGetParams {
  controlKindId: string;
  knmKindId: string;
  subjectKindIds?: string[];
}

export const dictionariesKnoSupervisionGet = (knoVersionId: string, supervisionVersionId: string) =>
  action(DictionariesActionsEnum.DICTIONARIES_KNO_SUPERVISION_GET, { knoVersionId, supervisionVersionId });
export const dictionariesKnoSupervisionGetRequest = (knoVersionId: string, supervisionVersionId: string) =>
  action(DictionariesActionsEnum.DICTIONARIES_KNO_SUPERVISION_GET_REQUEST, { knoVersionId, supervisionVersionId });
export const dictionariesKnoSupervisionGetSuccess = (
  data: IControlWithDate,
  knoVersionId: string,
  supervisionVersionId: string,
) =>
  action(DictionariesActionsEnum.DICTIONARIES_KNO_SUPERVISION_GET_SUCCESS, {
    data,
    knoVersionId,
    supervisionVersionId,
  });
export const dictionariesKnoSupervisionGetFailure = (knoVersionId: string, supervisionVersionId: string) =>
  action(DictionariesActionsEnum.DICTIONARIES_KNO_SUPERVISION_GET_FAILURE, {
    knoVersionId,
    supervisionVersionId,
  });

export const dictionariesEventUuidGet = (
  knoVersionId: string,
  supervisionVersionId: string,
  knmKindVersionId: string,
) =>
  action(DictionariesActionsEnum.DICTIONARIES_EVENT_UUID_GET, { knoVersionId, supervisionVersionId, knmKindVersionId });
export const dictionariesEventUuidGetRequest = (
  knoVersionId: string,
  supervisionVersionId: string,
  knmKindVersionId: string,
) =>
  action(DictionariesActionsEnum.DICTIONARIES_EVENT_UUID_GET_REQUEST, {
    knoVersionId,
    supervisionVersionId,
    knmKindVersionId,
  });
export const dictionariesEventUuidGetSuccess = (
  data: string[],
  knoVersionId: string,
  supervisionVersionId: string,
  knmKindVersionId: string,
) =>
  action(DictionariesActionsEnum.DICTIONARIES_EVENT_UUID_GET_SUCCESS, {
    data,
    knoVersionId,
    supervisionVersionId,
    knmKindVersionId,
  });
export const dictionariesEventUuidGetFailure = (
  knoVersionId: string,
  supervisionVersionId: string,
  knmKindVersionId: string,
) =>
  action(DictionariesActionsEnum.DICTIONARIES_EVENT_UUID_GET_FAILURE, {
    knoVersionId,
    supervisionVersionId,
    knmKindVersionId,
  });

export const dictionariesEventHasUnplannedActivityGet = (
  knoVersionId: string,
  supervisionVersionId: string,
  knmKindVersionId: string,
) =>
  action(DictionariesActionsEnum.DICTIONARIES_EVENT_HAS_UNPLANNED_ACTIVITY_GET, {
    knoVersionId,
    supervisionVersionId,
    knmKindVersionId,
  });
export const dictionariesEventHasUnplannedActivityGetRequest = (
  knoVersionId: string,
  supervisionVersionId: string,
  knmKindVersionId: string,
) =>
  action(DictionariesActionsEnum.DICTIONARIES_EVENT_HAS_UNPLANNED_ACTIVITY_GET_REQUEST, {
    knoVersionId,
    supervisionVersionId,
    knmKindVersionId,
  });
export const dictionariesEventHasUnplannedActivityGetSuccess = (
  data: boolean,
  knoVersionId: string,
  supervisionVersionId: string,
  knmKindVersionId: string,
) =>
  action(DictionariesActionsEnum.DICTIONARIES_EVENT_HAS_UNPLANNED_ACTIVITY_GET_SUCCESS, {
    data,
    knoVersionId,
    supervisionVersionId,
    knmKindVersionId,
  });
export const dictionariesEventHasUnplannedActivityGetFailure = (
  knoVersionId: string,
  supervisionVersionId: string,
  knmKindVersionId: string,
) =>
  action(DictionariesActionsEnum.DICTIONARIES_EVENT_HAS_UNPLANNED_ACTIVITY_GET_FAILURE, {
    knoVersionId,
    supervisionVersionId,
    knmKindVersionId,
  });

export const dictionariesGet = () => action(DictionariesActionsEnum.DICTIONARIES_GET);
export const dictionariesGetRequest = () => action(DictionariesActionsEnum.DICTIONARIES_GET_REQUEST);
export const dictionariesGetSuccess = (data: IDictionary[]) =>
  action(DictionariesActionsEnum.DICTIONARIES_GET_SUCCESS, { data });
export const dictionariesGetFailure = () => action(DictionariesActionsEnum.DICTIONARIES_GET_FAILURE);
export const dictionariesItemValuesGet = (dictionaryName: DictionaryNamesEnum) =>
  action(DictionariesActionsEnum.DICTIONARIES_ITEM_VALUES_GET, { dictionaryName });
export const dictionariesItemValuesGetRequest = (dictionaryName: DictionaryNamesEnum) =>
  action(DictionariesActionsEnum.DICTIONARIES_ITEM_VALUES_GET_REQUEST, { dictionaryName });
export const dictionariesItemValuesGetSuccess = (dictionaryName: DictionaryNamesEnum, data: IDictionaryVersion[]) =>
  action(DictionariesActionsEnum.DICTIONARIES_ITEM_VALUES_GET_SUCCESS, { dictionaryName, data });
export const dictionariesItemValuesGetFailure = (dictionaryName: DictionaryNamesEnum) =>
  action(DictionariesActionsEnum.DICTIONARIES_ITEM_VALUES_GET_FAILURE, { dictionaryName });

export const dictionariesItemValueGet = (dictionaryUUID: DictionaryUUIDsEnum, dictionaryVersionUUID: string) =>
  action(DictionariesActionsEnum.DICTIONARIES_ITEM_VALUE_GET, { dictionaryUUID, dictionaryVersionUUID });
export const dictionariesItemValueGetRequest = (dictionaryUUID: DictionaryUUIDsEnum, dictionaryVersionUUID: string) =>
  action(DictionariesActionsEnum.DICTIONARIES_ITEM_VALUE_GET_REQUEST, { dictionaryUUID, dictionaryVersionUUID });
export const dictionariesItemValueGetSuccess = <DataType>(
  dictionaryUUID: DictionaryUUIDsEnum,
  dictionaryVersionUUID: string,
  data: IDictionaryValue<DataType>,
) =>
  action(DictionariesActionsEnum.DICTIONARIES_ITEM_VALUE_GET_SUCCESS, { dictionaryUUID, dictionaryVersionUUID, data });
export const dictionariesItemValueGetFailure = (dictionaryUUID: DictionaryUUIDsEnum, dictionaryVersionUUID: string) =>
  action(DictionariesActionsEnum.DICTIONARIES_ITEM_VALUE_GET_FAILURE, { dictionaryUUID, dictionaryVersionUUID });
export const dictionariesItemValueGetNoData = (dictionaryUUID: DictionaryUUIDsEnum, dictionaryVersionUUID: string) =>
  action(DictionariesActionsEnum.DICTIONARIES_ITEM_VALUE_GET_NO_DATA, { dictionaryUUID, dictionaryVersionUUID });
export const dictionariesItemValueGetAlreadyLoad = (
  dictionaryUUID: DictionaryUUIDsEnum,
  dictionaryVersionUUID: string,
) =>
  action(DictionariesActionsEnum.DICTIONARIES_ITEM_VALUE_GET_ALREADY_LOAD, { dictionaryUUID, dictionaryVersionUUID });

export const dictionariesItemValueGetWithCallback = (
  dictionaryUUID: DictionaryUUIDsEnum,
  dictionaryVersionUUID: string,
  callbackAction: string,
) =>
  action(DictionariesActionsEnum.DICTIONARIES_ITEM_VALUE_GET_WITH_CALLBACK, {
    dictionaryUUID,
    dictionaryVersionUUID,
    callbackAction,
  });
export const dictionariesItemValueGetRequestWithCallback = (
  dictionaryUUID: DictionaryUUIDsEnum,
  dictionaryVersionUUID: string,
) =>
  action(DictionariesActionsEnum.DICTIONARIES_ITEM_VALUE_GET_REQUEST_WITH_CALLBACK, {
    dictionaryUUID,
    dictionaryVersionUUID,
  });
export const dictionariesItemValueGetSuccessWithCallback = <DataType>(
  dictionaryUUID: DictionaryUUIDsEnum,
  dictionaryVersionUUID: string,
  data: IDictionaryValue<DataType>,
) =>
  action(DictionariesActionsEnum.DICTIONARIES_ITEM_VALUE_GET_SUCCESS_WITH_CALLBACK, {
    dictionaryUUID,
    dictionaryVersionUUID,
    data,
  });
export const dictionariesItemValueGetFailureWithCallback = (
  dictionaryUUID: DictionaryUUIDsEnum,
  dictionaryVersionUUID: string,
) =>
  action(DictionariesActionsEnum.DICTIONARIES_ITEM_VALUE_GET_FAILURE_WITH_CALLBACK, {
    dictionaryUUID,
    dictionaryVersionUUID,
  });

export const supervisionDictionaryValueGet = (
  knoDictionaryVersionUUID: string,
  supervisionDictionaryVersionUUID: string,
) =>
  action(DictionariesActionsEnum.SUPERVISION_DICTIONARY_VALUE_GET, {
    knoDictionaryVersionUUID,
    supervisionDictionaryVersionUUID,
  });

export const dictionariesKnoOrganizationsItemUpdate = () =>
  action(DictionariesActionsEnum.DICTIONARIES_KNO_ORGANIZATIONS_ITEM_UPDATE);
export const dictionariesKnoOrganizationsItemGet = () =>
  action(DictionariesActionsEnum.DICTIONARIES_KNO_ORGANIZATIONS_ITEM_GET);
export const dictionariesKnoOrganizationsItemGetRequest = () =>
  action(DictionariesActionsEnum.DICTIONARIES_KNO_ORGANIZATIONS_ITEM_GET_REQUEST);
export const dictionariesKnoOrganizationsItemGetSuccess = (data: IDictionaryValues<IKnoOrganizationDictionary>) =>
  action(DictionariesActionsEnum.DICTIONARIES_KNO_ORGANIZATIONS_ITEM_GET_SUCCESS, { data });
export const dictionariesKnoOrganizationsItemGetFailure = () =>
  action(DictionariesActionsEnum.DICTIONARIES_KNO_ORGANIZATIONS_ITEM_GET_FAILURE);

export const dictionariesPositionsItemGet = (knoSupervisionUuid?: string) =>
  action(DictionariesActionsEnum.DICTIONARIES_POSITIONS_ITEM_GET, { knoSupervisionUuid });
export const dictionariesPositionsItemGetRequest = (knoSupervisionUuid?: string) =>
  action(DictionariesActionsEnum.DICTIONARIES_POSITIONS_ITEM_GET_REQUEST, { knoSupervisionUuid });
export const dictionariesPositionsItemGetSuccess = (data: IDictionaryValues<IPosition>, knoSupervisionUuid?: string) =>
  action(DictionariesActionsEnum.DICTIONARIES_POSITIONS_ITEM_GET_SUCCESS, { data, knoSupervisionUuid });
export const dictionariesPositionsItemGetFailure = (knoSupervisionUuid?: string) =>
  action(DictionariesActionsEnum.DICTIONARIES_POSITIONS_ITEM_GET_FAILURE, { knoSupervisionUuid });

/**
 * Статусы запроса на получение списка разрешительных документов через id вида контроля
 */
export const dictionariesPermitDocsItemGet = (controlKindUuid: string, uuidKno: string) =>
  action(DictionariesActionsEnum.DICTIONARIES_PERMIT_DOCS_ITEM_GET, { controlKindUuid, uuidKno });
export const dictionariesPermitDocsItemGetRequest = (controlKindUuid?: string, uuidKno?: string) =>
  action(DictionariesActionsEnum.DICTIONARIES_PERMIT_DOCS_ITEM_GET_REQUEST, { controlKindUuid, uuidKno });
export const dictionariesPermitDocsItemGetSuccess = (data: IPermitDocs[], controlKindUuid?: string, uuidKno?: string) =>
  action(DictionariesActionsEnum.DICTIONARIES_PERMIT_DOCS_ITEM_GET_SUCCESS, { data, controlKindUuid, uuidKno });
export const dictionariesPermitDocsItemGetFailure = (controlKindUuid?: string, uuidKno?: string) =>
  action(DictionariesActionsEnum.DICTIONARIES_PERMIT_DOCS_ITEM_GET_FAILURE, { controlKindUuid, uuidKno });

export const dictionariesParticipantPositionsItemGet = (knoSupervisionUuid?: string) =>
  action(DictionariesActionsEnum.DICTIONARIES_PARTICIPANT_POSITIONS_ITEM_GET, { knoSupervisionUuid });
export const dictionariesParticipantPositionsItemGetRequest = (knoSupervisionUuid?: string) =>
  action(DictionariesActionsEnum.DICTIONARIES_PARTICIPANT_POSITIONS_ITEM_GET_REQUEST, { knoSupervisionUuid });
export const dictionariesParticipantPositionsItemGetSuccess = (
  data: IDictionaryValues<IParticipantPosition>,
  knoSupervisionUuid?: string,
) => action(DictionariesActionsEnum.DICTIONARIES_PARTICIPANT_POSITIONS_ITEM_GET_SUCCESS, { data, knoSupervisionUuid });
export const dictionariesParticipantPositionsItemGetFailure = (knoSupervisionUuid?: string) =>
  action(DictionariesActionsEnum.DICTIONARIES_PARTICIPANT_POSITIONS_ITEM_GET_FAILURE, { knoSupervisionUuid });

export const dictionariesKnmKindsItemGet = (triplet?: ITripletKnoSupervisionCondition) =>
  action(DictionariesActionsEnum.DICTIONARIES_KNM_KIND_ITEM_GET, { triplet });
export const dictionariesKnmKindsItemGetRequest = (triplet?: ITripletKnoSupervisionCondition) =>
  action(DictionariesActionsEnum.DICTIONARIES_KNM_KIND_ITEM_GET_REQUEST, { triplet });
export const dictionariesKnmKindsItemGetSuccess = (
  data: IDictionaryValues<IKnmKind>,
  triplet?: ITripletKnoSupervisionCondition,
) => action(DictionariesActionsEnum.DICTIONARIES_KNM_KIND_ITEM_GET_SUCCESS, { data, triplet });
export const dictionariesKnmKindsItemGetFailure = (triplet?: ITripletKnoSupervisionCondition) =>
  action(DictionariesActionsEnum.DICTIONARIES_KNM_KIND_ITEM_GET_FAILURE, { triplet });

export const dictionariesDecisionKindsItemGet = (pair?: IPairKnoSupervisionVersions) =>
  action(DictionariesActionsEnum.DICTIONARIES_DECISION_KIND_ITEM_GET, { pair });
export const dictionariesDecisionKindsItemGetRequest = (pair?: IPairKnoSupervisionVersions) =>
  action(DictionariesActionsEnum.DICTIONARIES_DECISION_KIND_ITEM_GET_REQUEST, { pair });
export const dictionariesDecisionKindsItemGetSuccess = (
  data: IDictionaryValues<IDecisionKind>,
  pair?: IPairKnoSupervisionVersions,
) => action(DictionariesActionsEnum.DICTIONARIES_DECISION_KIND_ITEM_GET_SUCCESS, { data, pair });
export const dictionariesDecisionKindsItemGetFailure = (pair?: IPairKnoSupervisionVersions) =>
  action(DictionariesActionsEnum.DICTIONARIES_DECISION_KIND_ITEM_GET_FAILURE, { pair });

export const dictionariesDecisionKindsAllItemGet = (pair?: IPairKnoSupervisionVersions) =>
  action(DictionariesActionsEnum.DICTIONARIES_DECISION_KIND_ALL_ITEM_GET, { pair });
export const dictionariesDecisionKindsAllItemGetRequest = (pair?: IPairKnoSupervisionVersions) =>
  action(DictionariesActionsEnum.DICTIONARIES_DECISION_KIND_ALL_ITEM_GET_REQUEST, { pair });
export const dictionariesDecisionKindsAllItemGetSuccess = (
  data: IDictionaryValues<IDecisionKind>,
  pair?: IPairKnoSupervisionVersions,
) => action(DictionariesActionsEnum.DICTIONARIES_DECISION_KIND_ALL_ITEM_GET_SUCCESS, { data, pair });
export const dictionariesDecisionKindsAllItemGetFailure = (pair?: IPairKnoSupervisionVersions) =>
  action(DictionariesActionsEnum.DICTIONARIES_DECISION_KIND_ALL_ITEM_GET_FAILURE, { pair });

export const dictionariesProfKindsItemGet = (pair?: IPairKnoSupervisionVersions, conditionUuid?: string) =>
  action(DictionariesActionsEnum.DICTIONARIES_PROF_KIND_ITEM_GET, { pair, conditionUuid });
export const dictionariesProfKindsItemGetRequest = (pair?: IPairKnoSupervisionVersions, conditionUuid?: string) =>
  action(DictionariesActionsEnum.DICTIONARIES_PROF_KIND_ITEM_GET_REQUEST, { pair, conditionUuid });
export const dictionariesProfKindsItemGetSuccess = (
  data: IDictionaryValues<IProfKind>,
  pair?: IPairKnoSupervisionVersions,
  conditionUuid?: string,
) => action(DictionariesActionsEnum.DICTIONARIES_PROF_KIND_ITEM_GET_SUCCESS, { data, pair, conditionUuid });
export const dictionariesProfKindsItemGetFailure = (pair?: IPairKnoSupervisionVersions, conditionUuid?: string) =>
  action(DictionariesActionsEnum.DICTIONARIES_PROF_KIND_ITEM_GET_FAILURE, { pair, conditionUuid });

export const dictionariesAcceptedDocumentsItemGet = (pair?: IPairKnoSupervisionVersions) =>
  action(DictionariesActionsEnum.DICTIONARIES_ACCEPTED_DOCUMENT_ITEM_GET, { pair });
export const dictionariesAcceptedDocumentsItemGetRequest = (pair?: IPairKnoSupervisionVersions) =>
  action(DictionariesActionsEnum.DICTIONARIES_ACCEPTED_DOCUMENT_ITEM_GET_REQUEST, { pair });
export const dictionariesAcceptedDocumentsItemGetSuccess = (
  data: IDictionaryValues<IAcceptedDocument>,
  pair?: IPairKnoSupervisionVersions,
) => action(DictionariesActionsEnum.DICTIONARIES_ACCEPTED_DOCUMENT_ITEM_GET_SUCCESS, { data, pair });
export const dictionariesAcceptedDocumentsItemGetFailure = (pair?: IPairKnoSupervisionVersions) =>
  action(DictionariesActionsEnum.DICTIONARIES_ACCEPTED_DOCUMENT_ITEM_GET_FAILURE, { pair });

export const dictionariesRiskCategoriesItemGet = (
  knoSupervisionUuid: string | undefined,
  conditionUuid?: string | undefined,
  orderVersionUuid?: string | undefined,
  knmKindUuid?: string | undefined,
  isPlanned?: boolean | undefined,
) =>
  action(DictionariesActionsEnum.DICTIONARIES_RISK_CATEGORY_ITEM_GET, {
    knoSupervisionUuid,
    conditionUuid,
    orderVersionUuid,
    knmKindUuid,
    isPlanned,
  });
export const dictionariesRiskCategoriesItemGetUpdate = (
  knoSupervisionUuid: string | undefined,
  conditionUuid: string | undefined,
  orderVersionUuid: string | undefined,
  isPlanned: boolean | undefined,
) =>
  action(DictionariesActionsEnum.DICTIONARIES_RISK_CATEGORY_ITEM_GET_UPDATE, {
    knoSupervisionUuid,
    conditionUuid,
    orderVersionUuid,
    isPlanned,
  });
export const requestRiskCategoriesUpdate = (knoSupervisionUuid: string | undefined) =>
  action(DictionariesActionsEnum.DECISION_REQUEST_RISK_CATEGORIES_UPDATE, {
    knoSupervisionUuid,
  });
export const dictionariesRiskCategoriesItemGetRequest = (
  knoSupervisionUuid: string | undefined,
  conditionUuid: string | undefined,
  orderVersionUuid: string | undefined,
  knmKindUuid: string | undefined,
  isPlanned: boolean | undefined,
) =>
  action(DictionariesActionsEnum.DICTIONARIES_RISK_CATEGORY_ITEM_GET_REQUEST, {
    knoSupervisionUuid,
    conditionUuid,
    orderVersionUuid,
    knmKindUuid,
    isPlanned,
  });
export const dictionariesRiskCategoriesItemGetSuccess = (
  data: IDictionaryValues<IRiskCategory248>,
  knoSupervisionUuid: string | undefined,
  conditionUuid: string | undefined,
  orderVersionUuid: string | undefined,
  knmKindUuid: string | undefined,
  isPlanned: boolean | undefined,
) =>
  action(DictionariesActionsEnum.DICTIONARIES_RISK_CATEGORY_ITEM_GET_SUCCESS, {
    data,
    knoSupervisionUuid,
    conditionUuid,
    orderVersionUuid,
    knmKindUuid,
    isPlanned,
  });
export const dictionariesRiskCategoriesItemGetFailure = (
  knoSupervisionUuid: string | undefined,
  conditionUuid: string | undefined,
  orderVersionUuid: string | undefined,
  knmKindUuid: string | undefined,
  isPlanned: boolean | undefined,
) =>
  action(DictionariesActionsEnum.DICTIONARIES_RISK_CATEGORY_ITEM_GET_FAILURE, {
    knoSupervisionUuid,
    conditionUuid,
    orderVersionUuid,
    knmKindUuid,
    isPlanned,
  });

export const dictionariesDangerClassesItemGet = (
  knoSupervisionUuid: string | undefined,
  conditionUuid: string | undefined,
  orderVersionUuid: string | undefined,
  isPlanned: boolean | undefined,
) =>
  action(DictionariesActionsEnum.DICTIONARIES_DANGER_CLASS_ITEM_GET, {
    knoSupervisionUuid,
    conditionUuid,
    orderVersionUuid,
    isPlanned,
  });
export const dictionariesDangerClassesItemGetRequest = (
  knoSupervisionUuid: string | undefined,
  conditionUuid: string | undefined,
  orderVersionUuid: string | undefined,
  isPlanned: boolean | undefined,
) =>
  action(DictionariesActionsEnum.DICTIONARIES_DANGER_CLASS_ITEM_GET_REQUEST, {
    knoSupervisionUuid,
    conditionUuid,
    orderVersionUuid,
    isPlanned,
  });
export const dictionariesDangerClassesItemGetSuccess = (
  data: IDictionaryValues<IDangerClass248>,
  knoSupervisionUuid: string | undefined,
  conditionUuid: string | undefined,
  orderVersionUuid: string | undefined,
  isPlanned: boolean | undefined,
) =>
  action(DictionariesActionsEnum.DICTIONARIES_DANGER_CLASS_ITEM_GET_SUCCESS, {
    data,
    knoSupervisionUuid,
    conditionUuid,
    orderVersionUuid,
    isPlanned,
  });
export const dictionariesDangerClassesItemGetFailure = (
  knoSupervisionUuid: string | undefined,
  conditionUuid: string | undefined,
  orderVersionUuid: string | undefined,
  isPlanned: boolean | undefined,
) =>
  action(DictionariesActionsEnum.DICTIONARIES_DANGER_CLASS_ITEM_GET_FAILURE, {
    knoSupervisionUuid,
    conditionUuid,
    orderVersionUuid,
    isPlanned,
  });

export const dictionariesSubjectTypesItemGet = (
  knoSupervisionUuid?: string,
  conditionUuid?: string,
  orderVersionUuid?: string,
) =>
  action(DictionariesActionsEnum.DICTIONARIES_SUBJECT_TYPE_ITEM_GET, {
    knoSupervisionUuid,
    conditionUuid,
    orderVersionUuid,
  });
export const dictionariesSubjectTypesItemGetRequest = (
  knoSupervisionUuid?: string,
  conditionUuid?: string,
  orderVersionUuid?: string,
) =>
  action(DictionariesActionsEnum.DICTIONARIES_SUBJECT_TYPE_ITEM_GET_REQUEST, {
    knoSupervisionUuid,
    conditionUuid,
    orderVersionUuid,
  });
export const dictionariesSubjectTypesItemGetSuccess = (
  data: IDictionaryValues<ISubjectType>,
  knoSupervisionUuid?: string,
  conditionUuid?: string,
  orderVersionUuid?: string,
) =>
  action(DictionariesActionsEnum.DICTIONARIES_SUBJECT_TYPE_ITEM_GET_SUCCESS, {
    data,
    knoSupervisionUuid,
    conditionUuid,
    orderVersionUuid,
  });
export const dictionariesSubjectTypesItemGetFailure = (
  knoSupervisionUuid?: string,
  conditionUuid?: string,
  orderVersionUuid?: string,
) =>
  action(DictionariesActionsEnum.DICTIONARIES_SUBJECT_TYPE_ITEM_GET_FAILURE, {
    knoSupervisionUuid,
    conditionUuid,
    orderVersionUuid,
  });

export const dictionariesSubjectTypesMultiItemGet = (knoVersionIds: string[], supervisionVersionIds: string[]) =>
  action(DictionariesActionsEnum.DICTIONARIES_SUBJECT_TYPE_MULTI_ITEM_GET, { knoVersionIds, supervisionVersionIds });
export const dictionariesSubjectTypesMultiItemGetRequest = (knoVersionIds: string[], supervisionVersionIds: string[]) =>
  action(DictionariesActionsEnum.DICTIONARIES_SUBJECT_TYPE_MULTI_ITEM_GET_REQUEST, {
    knoVersionIds,
    supervisionVersionIds,
  });
export const dictionariesSubjectTypesMultiItemGetSuccess = (
  data: IDictionaryValues<ISubjectType>,
  knoVersionIds: string[],
  supervisionVersionIds: string[],
) =>
  action(DictionariesActionsEnum.DICTIONARIES_SUBJECT_TYPE_MULTI_ITEM_GET_SUCCESS, {
    data,
    knoVersionIds,
    supervisionVersionIds,
  });
export const dictionariesSubjectTypesMultiItemGetFailure = (knoVersionIds: string[], supervisionVersionIds: string[]) =>
  action(DictionariesActionsEnum.DICTIONARIES_SUBJECT_TYPE_MULTI_ITEM_GET_FAILURE, {
    knoVersionIds,
    supervisionVersionIds,
  });

export const dictionariesSubjectKindsMultiItemGet = (knoVersionIds: string[], supervisionVersionIds: string[]) =>
  action(DictionariesActionsEnum.DICTIONARIES_SUBJECT_KIND_MULTI_ITEM_GET, { knoVersionIds, supervisionVersionIds });
export const dictionariesSubjectKindsMultiItemGetRequest = (knoVersionIds: string[], supervisionVersionIds: string[]) =>
  action(DictionariesActionsEnum.DICTIONARIES_SUBJECT_KIND_MULTI_ITEM_GET_REQUEST, {
    knoVersionIds,
    supervisionVersionIds,
  });
export const dictionariesSubjectKindsMultiItemGetSuccess = (
  data: IDictionaryValues<ISubjectKind>,
  knoVersionIds: string[],
  supervisionVersionIds: string[],
) =>
  action(DictionariesActionsEnum.DICTIONARIES_SUBJECT_KIND_MULTI_ITEM_GET_SUCCESS, {
    data,
    knoVersionIds,
    supervisionVersionIds,
  });
export const dictionariesSubjectKindsMultiItemGetFailure = (knoVersionIds: string[], supervisionVersionIds: string[]) =>
  action(DictionariesActionsEnum.DICTIONARIES_SUBJECT_KIND_MULTI_ITEM_GET_FAILURE, {
    knoVersionIds,
    supervisionVersionIds,
  });

export const dictionariesSubjectSubKindsMultiItemGet = (knoVersionIds: string[], supervisionVersionIds: string[]) =>
  action(DictionariesActionsEnum.DICTIONARIES_SUBJECT_SUB_KIND_MULTI_ITEM_GET, {
    knoVersionIds,
    supervisionVersionIds,
  });
export const dictionariesSubjectSubKindsMultiItemGetRequest = (
  knoVersionIds: string[],
  supervisionVersionIds: string[],
) =>
  action(DictionariesActionsEnum.DICTIONARIES_SUBJECT_SUB_KIND_MULTI_ITEM_GET_REQUEST, {
    knoVersionIds,
    supervisionVersionIds,
  });
export const dictionariesSubjectSubKindsMultiItemGetSuccess = (
  data: IDictionaryValues<ISubjectKind>,
  knoVersionIds: string[],
  supervisionVersionIds: string[],
) =>
  action(DictionariesActionsEnum.DICTIONARIES_SUBJECT_SUB_KIND_MULTI_ITEM_GET_SUCCESS, {
    data,
    knoVersionIds,
    supervisionVersionIds,
  });
export const dictionariesSubjectSubKindsMultiItemGetFailure = (
  knoVersionIds: string[],
  supervisionVersionIds: string[],
) =>
  action(DictionariesActionsEnum.DICTIONARIES_SUBJECT_SUB_KIND_MULTI_ITEM_GET_FAILURE, {
    knoVersionIds,
    supervisionVersionIds,
  });

export const dictionariesSubjectKindsItemGet = (
  knoSupervisionUuid?: string,
  conditionUuid?: string,
  orderVersionUuid?: string,
  objectTypeDictVersionId?: string,
) =>
  action(DictionariesActionsEnum.DICTIONARIES_SUBJECT_KIND_ITEM_GET, {
    knoSupervisionUuid,
    conditionUuid,
    orderVersionUuid,
    objectTypeDictVersionId,
  });
export const dictionariesSubjectKindsItemGetRequest = (
  knoSupervisionUuid?: string,
  conditionUuid?: string,
  orderVersionUuid?: string,
  objectTypeDictVersionId?: string,
) =>
  action(DictionariesActionsEnum.DICTIONARIES_SUBJECT_KIND_ITEM_GET_REQUEST, {
    knoSupervisionUuid,
    conditionUuid,
    orderVersionUuid,
    objectTypeDictVersionId,
  });
export const dictionariesSubjectKindsItemGetSuccess = (
  data: IDictionaryValues<ISubjectKind>,
  knoSupervisionUuid?: string,
  conditionUuid?: string,
  orderVersionUuid?: string,
  objectTypeDictVersionId?: string,
) =>
  action(DictionariesActionsEnum.DICTIONARIES_SUBJECT_KIND_ITEM_GET_SUCCESS, {
    data,
    knoSupervisionUuid,
    conditionUuid,
    orderVersionUuid,
    objectTypeDictVersionId,
  });
export const dictionariesSubjectKindsItemGetFailure = (
  knoSupervisionUuid?: string,
  conditionUuid?: string,
  orderVersionUuid?: string,
  objectTypeDictVersionId?: string,
) =>
  action(DictionariesActionsEnum.DICTIONARIES_SUBJECT_KIND_ITEM_GET_FAILURE, {
    knoSupervisionUuid,
    conditionUuid,
    orderVersionUuid,
    objectTypeDictVersionId,
  });

export const dictionariesSubjectSubKindsItemGet = (
  knoSupervisionUuid?: string,
  conditionUuid?: string,
  orderVersionUuid?: string,
  objectTypeDictVersionId?: string,
) =>
  action(DictionariesActionsEnum.DICTIONARIES_SUBJECT_SUB_KIND_ITEM_GET, {
    knoSupervisionUuid,
    conditionUuid,
    orderVersionUuid,
    objectTypeDictVersionId,
  });
export const dictionariesSubjectSubKindsItemGetRequest = (
  knoSupervisionUuid?: string,
  conditionUuid?: string,
  orderVersionUuid?: string,
  objectTypeDictVersionId?: string,
) =>
  action(DictionariesActionsEnum.DICTIONARIES_SUBJECT_SUB_KIND_ITEM_GET_REQUEST, {
    knoSupervisionUuid,
    conditionUuid,
    orderVersionUuid,
    objectTypeDictVersionId,
  });
export const dictionariesSubjectSubKindsItemGetSuccess = (
  data: IDictionaryValues<ISubjectType>,
  knoSupervisionUuid?: string,
  conditionUuid?: string,
  orderVersionUuid?: string,
  objectTypeDictVersionId?: string,
) =>
  action(DictionariesActionsEnum.DICTIONARIES_SUBJECT_SUB_KIND_ITEM_GET_SUCCESS, {
    data,
    knoSupervisionUuid,
    conditionUuid,
    orderVersionUuid,
    objectTypeDictVersionId,
  });
export const dictionariesSubjectSubKindsItemGetFailure = (
  knoSupervisionUuid?: string,
  conditionUuid?: string,
  orderVersionUuid?: string,
  objectTypeDictVersionId?: string,
) =>
  action(DictionariesActionsEnum.DICTIONARIES_SUBJECT_SUB_KIND_ITEM_GET_FAILURE, {
    knoSupervisionUuid,
    conditionUuid,
    orderVersionUuid,
    objectTypeDictVersionId,
  });

export const dictionariesEventTypesItemGet = (
  isPm?: boolean,
  uniqueUuid?: string,
  conditionUuid?: string,
  orderVersionUuid?: string,
) =>
  action(DictionariesActionsEnum.DICTIONARIES_EVENT_TYPE_ITEM_GET, {
    isPm,
    uniqueUuid,
    conditionUuid,
    orderVersionUuid,
  });
export const dictionariesEventTypesItemGetRequest = (
  uniqueUuid?: string,
  conditionUuid?: string,
  orderVersionUuid?: string,
) =>
  action(DictionariesActionsEnum.DICTIONARIES_EVENT_TYPE_ITEM_GET_REQUEST, {
    uniqueUuid,
    conditionUuid,
    orderVersionUuid,
  });
export const dictionariesEventTypesItemGetSuccess = (
  data: IDictionaryValues<IEventType>,
  uniqueUuid?: string,
  conditionUuid?: string,
  orderVersionId?: string,
) =>
  action(DictionariesActionsEnum.DICTIONARIES_EVENT_TYPE_ITEM_GET_SUCCESS, {
    data,
    uniqueUuid,
    conditionUuid,
    orderVersionId,
  });
export const dictionariesEventTypesItemGetFailure = (
  uniqueUuid?: string,
  conditionUuid?: string,
  orderVersionUuid?: string,
) =>
  action(DictionariesActionsEnum.DICTIONARIES_EVENT_TYPE_ITEM_GET_FAILURE, {
    uniqueUuid,
    conditionUuid,
    orderVersionUuid,
  });

export const dictionariesPmProfEventTypesItemGet = (isUnableToRefuse?: boolean) =>
  action(DictionariesActionsEnum.DICTIONARIES_PM_PROF_EVENT_TYPE_ITEM_GET, {
    isUnableToRefuse,
  });
export const dictionariesPmProfEventTypesItemGetRequest = (isUnableToRefuse?: boolean) =>
  action(DictionariesActionsEnum.DICTIONARIES_PM_PROF_EVENT_TYPE_ITEM_GET_REQUEST, {
    isUnableToRefuse,
  });
export const dictionariesPmProfEventTypesItemGetSuccess = (
  data: IDictionaryValues<IEventType>,
  isUnableToRefuse?: boolean,
) =>
  action(DictionariesActionsEnum.DICTIONARIES_PM_PROF_EVENT_TYPE_ITEM_GET_SUCCESS, {
    data,
    isUnableToRefuse,
  });

export const dictionariesPmProfEventTypesItemGetFailure = (isUnableToRefuse?: boolean) =>
  action(DictionariesActionsEnum.DICTIONARIES_PM_PROF_EVENT_TYPE_ITEM_GET_FAILURE, {
    isUnableToRefuse,
  });

export const dictionariesSupervisionTypesItemClear = () =>
  action(DictionariesActionsEnum.DICTIONARIES_SUPERVISION_TYPE_ITEM_CLEAR);

export const dictionariesSupervisionTypesItemGet = (
  filterUUIDs: string[],
  isPlanned: boolean,
  federalLawUUIDs?: string[],
) =>
  action(DictionariesActionsEnum.DICTIONARIES_SUPERVISION_TYPE_ITEM_GET, {
    filterUUIDs,
    isPlanned,
    federalLawUUIDs,
  });
export const dictionariesSupervisionTypesItemGetRequest = (
  filterUUIDs: string[],
  isPlanned: boolean,
  federalLawUUIDs?: string[],
) =>
  action(DictionariesActionsEnum.DICTIONARIES_SUPERVISION_TYPE_ITEM_GET_REQUEST, {
    filterUUIDs,
    isPlanned,
    federalLawUUIDs,
  });

export const dictionariesSupervisionTypesItemGetSuccess = (
  data: IDictionaryValues<ISupervisionType>,
  filterUUIDs: string[],
  isPlanned: boolean,
  federalLawUUIDs?: string[],
) =>
  action(DictionariesActionsEnum.DICTIONARIES_SUPERVISION_TYPE_ITEM_GET_SUCCESS, {
    data,
    filterUUIDs,
    isPlanned,
    federalLawUUIDs,
  });

export const dictionariesSupervisionTypesItemGetFailure = (
  filterUUIDs: string[],
  isPlanned: boolean,
  federalLawUUIDs?: string[],
) =>
  action(DictionariesActionsEnum.DICTIONARIES_SUPERVISION_TYPE_ITEM_GET_FAILURE, {
    filterUUIDs,
    isPlanned,
    federalLawUUIDs,
  });

export const dictionariesSupervisionTypesBySubjectTypeItemGet = (subjectTypeUuid: string) =>
  action(DictionariesActionsEnum.DICTIONARIES_SUPERVISION_TYPE_BY_SUBJECT_TYPE_ITEM_GET, { subjectTypeUuid });
export const dictionariesSupervisionTypesBySubjectTypeItemGetRequest = (subjectTypeUuid: string) =>
  action(DictionariesActionsEnum.DICTIONARIES_SUPERVISION_TYPE_BY_SUBJECT_TYPE_ITEM_GET_REQUEST, { subjectTypeUuid });
export const dictionariesSupervisionTypesBySubjectTypeItemGetFailure = (subjectTypeUuid: string) =>
  action(DictionariesActionsEnum.DICTIONARIES_SUPERVISION_TYPE_BY_SUBJECT_TYPE_ITEM_GET_FAILURE, { subjectTypeUuid });
export const dictionariesSupervisionTypesBySubjectTypeItemGetSuccess = (
  data: IDictionaryValues<ISupervisionType>,
  subjectTypeUuid: string,
) =>
  action(DictionariesActionsEnum.DICTIONARIES_SUPERVISION_TYPE_BY_SUBJECT_TYPE_ITEM_GET_SUCCESS, {
    data,
    subjectTypeUuid,
  });

export const dictionariesChecklistsItemGet = (filterParams: IDictionariesChecklistsItemGetParams) =>
  action(DictionariesActionsEnum.DICTIONARIES_CHECKLIST_ITEM_GET, { filterParams });
export const dictionariesChecklistsItemGetRequest = (filterParams: IDictionariesChecklistsItemGetParams) =>
  action(DictionariesActionsEnum.DICTIONARIES_CHECKLIST_ITEM_GET_REQUEST, { filterParams });
export const dictionariesChecklistsItemGetSuccess = (
  data: IDictionaryValues<IChecklistDictionary>,
  filterParams: IDictionariesChecklistsItemGetParams,
) => action(DictionariesActionsEnum.DICTIONARIES_CHECKLIST_ITEM_GET_SUCCESS, { data, filterParams });
export const dictionariesChecklistsItemGetFailure = (filterParams: IDictionariesChecklistsItemGetParams) =>
  action(DictionariesActionsEnum.DICTIONARIES_CHECKLIST_ITEM_GET_FAILURE, { filterParams });

export const dictionariesRiskIndicatorsItemGet = (knoSupervisionUuid?: string) =>
  action(DictionariesActionsEnum.DICTIONARIES_RISK_INDICATORY_ITEM_GET, { knoSupervisionUuid });
export const dictionariesRiskIndicatorsItemGetRequest = (knoSupervisionUuid?: string) =>
  action(DictionariesActionsEnum.DICTIONARIES_RISK_INDICATORY_ITEM_GET_REQUEST, { knoSupervisionUuid });
export const dictionariesRiskIndicatorsItemGetSuccess = (
  data: IDictionaryValues<IRiskIndicatory>,
  knoSupervisionUuid?: string,
) => action(DictionariesActionsEnum.DICTIONARIES_RISK_INDICATORY_ITEM_GET_SUCCESS, { data, knoSupervisionUuid });
export const dictionariesRiskIndicatorsItemGetFailure = (knoSupervisionUuid?: string) =>
  action(DictionariesActionsEnum.DICTIONARIES_RISK_INDICATORY_ITEM_GET_FAILURE, { knoSupervisionUuid });

export const dictionariesRequirementsItemGet = (filterParams: IDictionariesRequirementsItemGetParams) =>
  action(DictionariesActionsEnum.DICTIONARIES_REQUIREMENT_ITEM_GET, { filterParams });
export const dictionariesRequirementsItemGetRequest = (filterParams: IDictionariesRequirementsItemGetParams) =>
  action(DictionariesActionsEnum.DICTIONARIES_REQUIREMENT_ITEM_GET_REQUEST, { filterParams });
export const dictionariesRequirementsItemGetSuccess = (
  data: IDictionaryValues<IRequirement>,
  filterParams: IDictionariesRequirementsItemGetParams,
) => action(DictionariesActionsEnum.DICTIONARIES_REQUIREMENT_ITEM_GET_SUCCESS, { data, filterParams });
export const dictionariesRequirementsItemGetFailure = (filterParams: IDictionariesRequirementsItemGetParams) =>
  action(DictionariesActionsEnum.DICTIONARIES_REQUIREMENT_ITEM_GET_FAILURE, { filterParams });

export const dictionariesErvkCheckListGet = (filterParams: IErvkListGetParams) =>
  action(DictionariesActionsEnum.ERVK_CHECK_LIST_GET, { filterParams });
export const dictionariesErvkCheckListGetRequest = (filterParams: IErvkListGetParams) =>
  action(DictionariesActionsEnum.ERVK_CHECK_LIST_GET_REQUEST, { filterParams });
export const dictionariesErvkCheckListGetSuccess = (data: IErvkCheckList[], filterParams: IErvkListGetParams) =>
  action(DictionariesActionsEnum.ERVK_CHECK_LIST_GET_SUCCESS, { data, filterParams });
export const dictionariesErvkCheckListGetFailure = (filterParams: IErvkListGetParams) =>
  action(DictionariesActionsEnum.ERVK_CHECK_LIST_GET_FAILURE, { filterParams });

export const dictionariesFederalLawsGet = () => action(DictionariesActionsEnum.DICTIONARIES_FEDERAL_LAWS_GET);
export const dictionariesFederalLawsGetRequest = () =>
  action(DictionariesActionsEnum.DICTIONARIES_FEDERAL_LAWS_GET_REQUEST);
export const dictionariesFederalLawsGetSuccess = (data: IDictionaryValues<IFederalLawErvk>) =>
  action(DictionariesActionsEnum.DICTIONARIES_FEDERAL_LAWS_GET_SUCCESS, { data });
export const dictionariesFederalLawsGetFailure = () =>
  action(DictionariesActionsEnum.DICTIONARIES_FEDERAL_LAWS_GET_FAILURE);

export const dictionariesKnmSubjectTypesGet = () => action(DictionariesActionsEnum.DICTIONARIES_KNM_SUBJECT_TYPES_GET);
export const dictionariesKnmSubjectTypesGetRequest = () =>
  action(DictionariesActionsEnum.DICTIONARIES_KNM_SUBJECT_TYPES_GET_REQUEST);
export const dictionariesKnmSubjectTypesGetSuccess = (data: IDictionaryValues<IKnmSubjectTypesERVK>) =>
  action(DictionariesActionsEnum.DICTIONARIES_KNM_SUBJECT_TYPES_GET_SUCCESS, { data });
export const dictionariesKnmSubjectTypesGetFailure = () =>
  action(DictionariesActionsEnum.DICTIONARIES_KNM_SUBJECT_TYPES_GET_FAILURE);

export const dictionariesTargetEntityItemGet = (triplet?: ITripletKnoSupervisionCondition) =>
  action(DictionariesActionsEnum.DICTIONARIES_TARGET_ENTITY_ITEM_GET, { triplet });
export const dictionariesTargetEntityItemGetRequest = (triplet?: ITripletKnoSupervisionCondition) =>
  action(DictionariesActionsEnum.DICTIONARIES_TARGET_ENTITY_ITEM_GET_REQUEST, { triplet });
export const dictionariesTargetEntityItemGetSuccess = (
  data: IDictionaryValues<ITargetEntity>,
  triplet?: ITripletKnoSupervisionCondition,
) => action(DictionariesActionsEnum.DICTIONARIES_TARGET_ENTITY_ITEM_GET_SUCCESS, { data, triplet });
export const dictionariesTargetEntityItemGetFailure = (triplet?: ITripletKnoSupervisionCondition) =>
  action(DictionariesActionsEnum.DICTIONARIES_TARGET_ENTITY_ITEM_GET_FAILURE, { triplet });

export const dictionariesTargetEntityFounderItemGet = () =>
  action(DictionariesActionsEnum.DICTIONARIES_TARGET_ENTITY_FOUNDER_ITEM_GET);
export const dictionariesTargetEntityFounderItemGetRequest = () =>
  action(DictionariesActionsEnum.DICTIONARIES_TARGET_ENTITY_FOUNDER_ITEM_GET_REQUEST);
export const dictionariesTargetEntityFounderItemGetSuccess = (data: IDictionaryValues<ITargetEntity>) =>
  action(DictionariesActionsEnum.DICTIONARIES_TARGET_ENTITY_FOUNDER_ITEM_GET_SUCCESS, { data });
export const dictionariesTargetEntityFounderItemGetFailure = () =>
  action(DictionariesActionsEnum.DICTIONARIES_TARGET_ENTITY_FOUNDER_ITEM_GET_FAILURE);

export const dictionariesKnmTypesItemGet = (knoSupervisionUuid?: string) =>
  action(DictionariesActionsEnum.DICTIONARIES_KNM_TYPES_ITEM_GET, { knoSupervisionUuid });
export const dictionariesKnmTypesItemGetRequest = (knoSupervisionUuid?: string) =>
  action(DictionariesActionsEnum.DICTIONARIES_KNM_TYPES_ITEM_GET_REQUEST, { knoSupervisionUuid });
export const dictionariesKnmTypesItemGetSuccess = (data: IKnmType[], knoSupervisionUuid?: string) =>
  action(DictionariesActionsEnum.DICTIONARIES_KNM_TYPES_ITEM_GET_SUCCESS, { data, knoSupervisionUuid });
export const dictionariesKnmTypesItemGetFailure = (knoSupervisionUuid?: string) =>
  action(DictionariesActionsEnum.DICTIONARIES_KNM_TYPES_ITEM_GET_FAILURE, { knoSupervisionUuid });
export const dictionariesKnoOrganisationsGet = () => action(DictionariesActionsEnum.DICTIONARIES_KNO_ORGANISATIONS_GET);
export const dictionariesKnoOrganisationsGetNextPage = () =>
  action(DictionariesActionsEnum.DICTIONARIES_KNO_ORGANISATIONS_GET_NEXT_PAGE);

export const dictionariesConditionTypesItemGet = (uniqueUuid?: string) =>
  action(DictionariesActionsEnum.DICTIONARIES_CONDITION_TYPES_ITEM_GET, { uniqueUuid });
export const dictionariesConditionTypesItemGetRequest = (uniqueUuid?: string) =>
  action(DictionariesActionsEnum.DICTIONARIES_CONDITION_TYPES_ITEM_GET_REQUEST, { uniqueUuid });
export const dictionariesConditionTypesItemGetSuccess = (data: IKnmReasonType[], uniqueUuid?: string) =>
  action(DictionariesActionsEnum.DICTIONARIES_CONDITION_TYPES_ITEM_GET_SUCCESS, {
    data,
    uniqueUuid,
  });
export const dictionariesConditionTypesItemGetFailure = (uniqueUuid?: string) =>
  action(DictionariesActionsEnum.DICTIONARIES_CONDITION_TYPES_ITEM_GET_FAILURE, { uniqueUuid });

export const dictionariesApplicationConditionSubjectsItemGet = (conditionUuid?: string, orderVersionUuid?: string) =>
  action(DictionariesActionsEnum.DICTIONARIES_APPLICATION_CONDITION_SUBJECTS_ITEM_GET, {
    conditionUuid,
    orderVersionUuid,
  });
export const dictionariesApplicationConditionSubjectsItemGetRequest = (
  conditionUuid?: string,
  orderVersionUuid?: string,
) =>
  action(DictionariesActionsEnum.DICTIONARIES_APPLICATION_CONDITION_SUBJECTS_ITEM_GET_REQUEST, {
    conditionUuid,
    orderVersionUuid,
  });
export const dictionariesApplicationConditionSubjectsItemGetSuccess = (
  data: IApplicationConditionSubject[],
  conditionUuid?: string,
  orderVersionUuid?: string,
) =>
  action(DictionariesActionsEnum.DICTIONARIES_APPLICATION_CONDITION_SUBJECTS_ITEM_GET_SUCCESS, {
    data,
    conditionUuid,
    orderVersionUuid,
  });
export const dictionariesApplicationConditionSubjectsItemGetFailure = (
  conditionUuid?: string,
  orderVersionUuid?: string,
) =>
  action(DictionariesActionsEnum.DICTIONARIES_APPLICATION_CONDITION_SUBJECTS_ITEM_GET_FAILURE, {
    conditionUuid,
    orderVersionUuid,
  });

export const dictionariesFindSubjectKindSelectOptionsByQuery = (
  query: string,
  callback: (options: ISelectOption[]) => void,
) => action(DictionariesActionsEnum.DICTIONARIES_FIND_SUBJECT_KIND_SELECT_OPTIONS_BY_QUERY, { query, callback });

export const dictionariesFindSubjectSubKindSelectOptionsByQuery = (
  query: string,
  callback: (options: ISelectOption[]) => void,
) => action(DictionariesActionsEnum.DICTIONARIES_FIND_SUBJECT_SUB_KIND_SELECT_OPTIONS_BY_QUERY, { query, callback });

export const dictionariesGetDocTargetSelectOptionsByQuery = (
  query: string,
  callback: (options: ISelectOption[]) => void,
) => action(DictionariesActionsEnum.DICTIONARIES_GET_DOC_TARGET_SELECT_OPTIONS_BY_QUERY, { query, callback });

export const dictionariesFilteredFederalLawsGet = (knoVersionId: string, isPm: boolean = false) =>
  action(DictionariesActionsEnum.DICTIONARIES_FILTERED_FEDERAL_LAWS_GET, { knoVersionId, isPm });

export const dictionariesFilteredFederalLawsGetSuccess = (data: IDictionaryValues<IFederalLawErvk>) =>
  action(DictionariesActionsEnum.DICTIONARIES_FILTERED_FEDERAL_LAWS_GET_SUCCESS, { data });

export const dictionariesFilteredFederalLawsGetFailure = () =>
  action(DictionariesActionsEnum.DICTIONARIES_FILTERED_FEDERAL_LAWS_GET_FAILURE);
export const dictionariesFilteredFederalLawsGetRequest = () =>
  action(DictionariesActionsEnum.DICTIONARIES_FILTERED_FEDERAL_LAWS_GET_REQUEST);
